import { createSlice } from '@reduxjs/toolkit';
import { ApiHelper } from '../../utils/apiHelper';

const initialState = {
  isAuthenticated: false,
  user: null,
  adminInfo: null,
  token: localStorage.getItem('token'),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('token', action.payload.token);
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.adminInfo = null;
      state.token = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('token');
      // Clear any other auth-related data from localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('adminInfo');
      // Clear the token from ApiHelper
      ApiHelper.setAuthToken(null);
    },
    fetchAdminInfoStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAdminInfoSuccess: (state, action) => {
      state.loading = false;
      state.adminInfo = action.payload;
    },
    fetchAdminInfoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout,
  fetchAdminInfoStart,
  fetchAdminInfoSuccess,
  fetchAdminInfoFailure,
} = authSlice.actions;

export const fetchAdminInfo = () => async (dispatch) => {
  try {
    dispatch(fetchAdminInfoStart());
    const response = await ApiHelper.get('/admin/admin-user-info');
    
    if (response?.data?.responseUser) {
      dispatch(fetchAdminInfoSuccess(response.data.responseUser));
    } else {
      dispatch(fetchAdminInfoFailure('Invalid response format'));
    }
  } catch (error) {
    console.error('Error fetching admin info:', error);
    dispatch(fetchAdminInfoFailure(error.message));
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch(loginStart());
    const response = await ApiHelper.post('/admin/login-admin-user', { email, password });
    
    if (response?.data?.token) {
      dispatch(loginSuccess({
        token: response.data.token,
        user: response.data.user
      }));
      
      // Token'ı ApiHelper'a da set edelim
      ApiHelper.setAuthToken(response.data.token);
      
      // Admin bilgilerini çek
      await dispatch(fetchAdminInfo());
      
      return true;
    } else {
      dispatch(loginFailure('Invalid response format'));
      return false;
    }
  } catch (error) {
    dispatch(loginFailure(error.message));
    return false;
  }
};

export const checkAuth = () => (dispatch, getState) => {
  const token = localStorage.getItem('token');
  if (token) {
    ApiHelper.setAuthToken(token);
    dispatch(loginSuccess({ token, user: null }));
  } else {
    dispatch(logout());
  }
};

export const logoutAndRedirect = () => (dispatch) => {
  dispatch(logout());
  // Redirect to login page
  window.location.href = '/login';
};

export default authSlice.reducer; 